import { Menu as _Menu, MenuProps as _MenuProps } from 'antd'

type MenuProps = _MenuProps

export function Menu(props: MenuProps) {
  return <_Menu {...props} />
}
